<template>
  <div class="hello">
    <div class="page1">
      <img class="paintRoom" src="../assets/img/Group 3@2x.png" alt="">
      <button @click="openAndroid" class="btn1"><img src="../assets/img/Group 2@2x.png" alt=""><span class="AndroidDownload">Android版下载</span></button>
      <button @click="openAppStore" class="btn2"><img src="../assets/img/Group@2x.png" alt=""><span class="iPhoneDownload"> iPhone版下载</span></button>
    </div>
    <div class="page2">
      <img src="../assets/img/Group 12@2x.png" alt="">
    </div>
    <div class="page3">
      <button @click="openAndroid" class="btn1 footer"><img src="../assets/img/Group 2@2x.png" alt=""><span class="AndroidDownload">Android版下载</span></button>
      <button @click="openAppStore" class="btn2 footer"><img src="../assets/img/Group@2x.png" alt=""><span class="iPhoneDownload"> iPhone版下载</span></button>
    </div>   
  </div>
</template>

<script>
export default {
  name: 'PaintingRoom',
  props: {
    msg: String
  },
  methods: {
    openAppStore(){
      window.location.href="https://apps.apple.com/cn/app/绘房/id1526244430"
    },
    openAndroid() {
      alert("敬请期待！！")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  *{
    margin:0;
    padding:0;
  }
  .hello {
    width: 100vw;
    height: calc(100vw / 375 * 720);
  }
  .page1{
    position: relative;
    width:100%;
    height: calc(100vw / 375 * 720);
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  .paintRoom{
    width:100%;
    height:calc(100vw / 375 * 720);
  }
  button{
    position: absolute;
    width:calc(100vw / 375 * 210);
    height:calc(100vw / 375 * 49);
    display: flex;
    align-items: center;
    justify-content: center;
    background:#fff;
    border-radius: calc(100vw / 375 * 10);
    border:calc(100vw / 375 * 0.5) solid #593A25;
  }
  .btn1{
    top:calc(100vw / 375 * 593.5);
  }
  .btn2{
    top:calc(100vw / 375 * 650.5);
  }
  button img{
    // border:calc(100vw / 375 * 0.5) dashed #593A25;
    width:calc(100vw / 375 * 38);
    height:calc(100vw / 375 * 38);
  }
  button span{
    color:#593A25;
    font-size: calc(100vw / 375 * 18);
    margin-left:calc(100vw / 375 * 6);
  }
  .page2{
    width:100vw;
    height:calc(100vw / 375 * 2600);
  }
  .page2 img{
    width:100%;
    height: 100%;
  }
  .page3{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn1.footer{
    top:calc(100vw / 375 * 3355);
  }
  .btn2.footer{
    top:calc(100vw / 375 * 3412);
    margin-bottom: calc(100vw / 375 * 42);
  }
</style>
